import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import SectoralMovementsFull from './sectoral-movements-full';

const SectoralMovementsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <SectoralMovementsFull {...props} />
    </QueryClientProvider>
  );
};

export { SectoralMovementsFullWidget }
